import { PlaylistItemData } from "../playlist/data/PlaylistItemData";
import { Fragment } from "react";
import { LookupSongFunction } from "../common/LookupSongFunction";

interface Props {
  playlistData: ReadonlyArray<PlaylistItemData>;
  lookupSong: LookupSongFunction;
}

export default function PlaylistSummaryItemList(props: Props) {
  return (
    <div className="my-2">
      {props.playlistData.map((entry) => {
        const tocEntry = props.lookupSong(entry.songEntryId);
        if (tocEntry) {
          return (
            <div className="row small" key={entry.id}>
              <div className="col-lg">&bull; {tocEntry.title}</div>
            </div>
          );
        } else {
          return <Fragment key={entry.id} />;
        }
      })}
    </div>
  );
}
